// Core cart validation helpers
function getCartValidationResults(cartItems) {
    if (!Array.isArray(cartItems)) {
      return {
        isValid: false,
        error: 'Cart items must be an array',
        orphanedChildren: [],
        validItems: []
      };
    }
  
    const itemsByBid = {};
    const orphanedChildren = [];
    const validItems = [];
  
    cartItems.forEach((item, index) => {
      const bid = item && item.properties ? item.properties._bid : undefined;
      if (bid) {
        if (!itemsByBid[bid]) itemsByBid[bid] = [];
        itemsByBid[bid].push({ ...item, __originalIndex: index });
      }
    });
    
    // Check if cart has any master products at all
    const hasAnyMaster = cartItems.some((item) => 
      item && item.properties && item.properties._bundleType === 'master'
    );
    
    // If cart has no master products, mark all child items as orphaned
    if (!hasAnyMaster) {
      cartItems.forEach((item, index) => {
        if (item && item.properties && item.properties._bundleType === 'child') {
          orphanedChildren.push({ ...item, __originalIndex: index });
        }
      });
    } else {
      // If master products exist, use existing bundle group validation logic
      Object.keys(itemsByBid).forEach((bid) => {
        const groupItems = itemsByBid[bid];
        const hasMaster = groupItems.some((it) => it && it.properties && it.properties._bundleType === 'master');
        if (hasMaster) {
          validItems.push(...groupItems);
        } else {
          orphanedChildren.push(...groupItems);
        }
      });
    }
   
    cartItems.forEach((item, index) => {
      const hasBid = item && item.properties ? item.properties._bid : undefined;
      if (!hasBid) validItems.push({ ...item, __originalIndex: index });
    });
  
    return {
      isValid: orphanedChildren.length === 0,
      orphanedChildren: orphanedChildren.map(({ __originalIndex, ...rest }) => rest),
      validItems: validItems
        .sort((a, b) => (a.__originalIndex || 0) - (b.__originalIndex || 0))
        .map(({ __originalIndex, ...rest }) => rest),
      totalItems: cartItems.length,
      validItemsCount: validItems.length,
      orphanedCount: orphanedChildren.length
    };
  }
  
  function removeOrphanedChildProducts(cartItems) {
    const results = getCartValidationResults(cartItems);
    return results.validItems;
  }
  
  // Utility to sync child quantities with master quantity for same bundle ID
  function syncChildQuantitiesWithMaster(cartItems) {
    if (!Array.isArray(cartItems)) return {};
    
    const itemsByBid = {};
    const quantityUpdates = {};
    
    // Group items by bundle ID
    cartItems.forEach((item) => {
      const bid = item && item.properties ? item.properties._bid : undefined;
      if (bid) {
        if (!itemsByBid[bid]) itemsByBid[bid] = [];
        itemsByBid[bid].push(item);
      }
    });
    
    // For each bundle group, sync child quantities with master quantity
    Object.keys(itemsByBid).forEach((bid) => {
      const groupItems = itemsByBid[bid];
      const masterItem = groupItems.find((it) => it && it.properties && it.properties._bundleType === 'master');
      
      if (masterItem && masterItem.quantity) {
        const masterQuantity = masterItem.quantity;
        const childItems = groupItems.filter((it) => it && it.properties && it.properties._bundleType === 'child');
        
        // Update child items to match master quantity
        childItems.forEach((childItem) => {
          if (childItem.key && childItem.quantity !== masterQuantity) {
            quantityUpdates[childItem.key] = masterQuantity;
          }
        });
      }
    });
    
    return quantityUpdates;
  }
  
  // Utility to remove specific line item keys from cart
  function cleanCart(orphanedItems) {
    if (!orphanedItems || orphanedItems.length === 0) return Promise.resolve();
    const updates = {};
    orphanedItems.forEach((item) => {
      if (item && item.key) updates[item.key] = 0;
    });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    }).then((r) => r.json());
  }
  
  function validateCartAndClean() {
    return fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const cartItems = cart.items || [];
        
        // First, sync child quantities with master quantities for same bundle ID
        const quantityUpdates = syncChildQuantitiesWithMaster(cartItems);
        if (Object.keys(quantityUpdates).length > 0) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: quantityUpdates })
          })
          .then((r) => r.json())
          .then(() => {
            // After syncing quantities, validate for orphaned children
            return fetch('/cart.js')
              .then((r) => r.json())
              .then((updatedCart) => {
                const results = getCartValidationResults(updatedCart.items || []);
                if (!results.isValid && results.orphanedCount > 0) {
                  return cleanCart(results.orphanedChildren).then(() => {
                    try { window.location.reload(); } catch (_) {}
                  });
                }
              });
          });
        }
        
        // If no quantity updates needed, just check for orphaned children
        const results = getCartValidationResults(cartItems);
        if (!results.isValid && results.orphanedCount > 0) {
          return cleanCart(results.orphanedChildren).then(() => {
            try { window.location.reload(); } catch (_) {}
          });
        }
      })
      .catch((err) => console.warn('Cart validation error:', err));
  }
  
  // Expose globals immediately (no DOMContentLoaded race)
  if (typeof window !== 'undefined') {
    window.getCartValidationResults = getCartValidationResults;
    window.removeOrphanedChildProducts = removeOrphanedChildProducts;
    window.validateCartManually = validateCartAndClean;
    window.syncChildQuantitiesWithMaster = syncChildQuantitiesWithMaster;
  }
  
  // Auto-run on load and cart updates
  (function ensureInit() {
    function run() {
      validateCartAndClean();
      document.addEventListener('cart:updated', function() {
        setTimeout(validateCartAndClean, 100);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();
  
  